import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgButtonDropdown = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={37} height={36} fill="none" viewBox="0 0 37 36" {...props}><Path fill="currentColor" d="M.006 10.587 3.107 7.5l14.899 14.826L32.904 7.5l3.102 3.087-18 17.913-18-17.913Z" /></Svg>;
const Memo = memo(SvgButtonDropdown);
export default Memo;